// extracted by mini-css-extract-plugin
export default {"title":"_31aae87847","bld":"_92ad59081f"};